import {
	GET_TICKETS,
    SAVE_TICKETS,
	RESET_TICKETS
} from '../constants/tickets';

export const getTickets = (data) => {
	return {
		type: GET_TICKETS,
		payload: data
	}
};

export const saveTickets = (tickets) => {
	return {
		type: SAVE_TICKETS,
        payload: tickets
	}
};

export const resetTickets = (tickets) => {
	return {
		type: RESET_TICKETS
	}
};
